/**
 * Indicates the current state of the instrument.
 * tag: 965
 * @readonly
 * @enum {string} (String)
 */
export enum SecurityStatus {
  Active = '1',
  Inactive = '2',
  ActiveClosingOrdersOnly = '3',
  Expired = '4',
  Delisted = '5',
  KnockedOut = '6',
  KnockOutRevoked = '7',
  PendingExpiry = '8',
  Suspended = '9',
  Published = '10',
  PendingDeletion = '11',
}
